// extracted by mini-css-extract-plugin
export default {"overlay":"PopUp2_overlay__2+Qpk","modal":"PopUp2_modal__pQFnf","closeBtn":"PopUp2_closeBtn__0p0ej"};